import { useState } from "react";
import {
  IOptionGreekSearchParam,
  OptionGreekOptionType,
} from "../../Interfaces/optionGreek";
import Form from "../../Components/Form";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import DatePicker from "../../Components/DatePicker";
import TextInput from "../../Components/TextInput";
import Button from "../../Components/Button";

import { getBaseInstruments } from "../../Requests/Order/tradeTableRequests";
import { getDueDates, getStatuses } from "../../Requests/optionGreek";
import TabBox from "../../Components/Tabbox/TabBox";
interface IProps {
  serverSearchParam: IOptionGreekSearchParam;
  onSubmit: (searchParam: IOptionGreekSearchParam) => void;
}

const SearchParamUI = ({ serverSearchParam, onSubmit }: IProps) => {
  const [searchParam, setSearchParam] =
    useState<IOptionGreekSearchParam>(serverSearchParam);

  const changeHandler = (name: string, value: any) => {
    if (value === "") value = null;
    setSearchParam({ ...searchParam, [name]: value });
  };

  const optionTypeChildren = [
    {
      index: 1,
      title: "اختیار خرید",
      value: OptionGreekOptionType.Call,
      className:
        searchParam?.optionType === OptionGreekOptionType.Call
          ? "!border-2 !border-green-600 !text-white hover:!border-green-700 !bg-green-600 hover:!bg-green-700 "
          : "!border-2 !border-gray-300 !text-gray-300 hover:!border-gray-400 hover:!text-gray-400",
    },
    {
      index: 2,
      title: "اختیار فروش",
      value: OptionGreekOptionType.Put,
      className:
        searchParam?.optionType === OptionGreekOptionType.Put
          ? "!border-2 !border-red-700 !text-white hover:!border-red-800 !bg-red-700 hover:!bg-red-800"
          : "!border-2 !border-gray-300 !text-gray-300 hover:!border-gray-400 hover:!text-gray-400",
    },
  ];

  return (
    <Form className="px-2 py-3 gap-3 !w-52">
      <TabBox
        children={optionTypeChildren}
        activeTab={searchParam.optionType}
        onChange={(name, _, value) => changeHandler(name, value)}
        name="optionType"
      />
      <DynamicDropdown
        dropdown={{
          name: "baseInsId",
          placeholder: "نماد پایه",
        }}
        onChange={changeHandler}
        getData={() => getBaseInstruments()}
        value={searchParam.baseInsId}
      />

      <DynamicDropdown
        dropdown={{
          name: "dueDate",
          placeholder: "روز سررسید",
          extraLabel: true,
          disabled: !searchParam.baseInsId,
        }}
        onChange={changeHandler}
        getData={() => getDueDates(searchParam.baseInsId)}
        inputId={searchParam.baseInsId}
        value={searchParam.dueDate}
      />

      <TextInput
        label="درصد اختلاف تا بلک شولز"
        value={searchParam.blackSholtzDeviationPercentage?.toString()}
        name="blackSholtzDeviationPercentage"
        onChange={changeHandler}
        kind="percent"
      />

      <DynamicDropdown
        dropdown={{
          name: "status",
          placeholder: "وضعیت",
          extraLabel: true,
        }}
        onChange={changeHandler}
        getData={getStatuses}
        value={searchParam.status}
      />

      <div className="flex flex-col justify-start items-start gap-1">
        <div className="text-xs">دلتا</div>
        <div className="flex flex-row justify-start items-center gap-3">
          <TextInput
            label=""
            name="fromDelta"
            value={searchParam.fromDelta?.toString()}
            onChange={changeHandler}
            kind="percent"
          />
          <div className="text-xs">تا</div>
          <TextInput
            label=""
            name="toDelta"
            value={searchParam.toDelta?.toString()}
            onChange={changeHandler}
            kind="percent"
          />
        </div>
      </div>
      <div className="flex flex-col justify-start items-start gap-1">
        <div className="text-xs">روز تا سررسید</div>
        <div className="flex flex-row justify-start items-center gap-3">
          <TextInput
            label=""
            name="fromRemainingDay"
            value={
              searchParam.fromRemainingDay == null
                ? ""
                : searchParam.fromRemainingDay?.toString()
            }
            onChange={changeHandler}
            kind="percent"
          />
          <div className="text-xs">تا</div>
          <TextInput
            label=""
            name="toRemainingDay"
            value={
              searchParam.toRemainingDay == null
                ? ""
                : searchParam.toRemainingDay?.toString()
            }
            onChange={changeHandler}
            kind="percent"
          />
        </div>
      </div>

      <TextInput
        label=" حداقل ارزش معاملات برحسب میلیون"
        name="minValue"
        onChange={changeHandler}
        kind="priceWithDecimal"
        value={searchParam.minValue}
      />

      <Button
        text="جستجو"
        onClick={() => onSubmit(searchParam)}
        variant="contained"
      />
    </Form>
  );
};

export default SearchParamUI;
